import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useRequest } from "hooks/useRequest";
import { fetchManifest } from "../../utils/fetchResearchReport";
import { ResearchChatPage } from "./ResearchChatPage";

export const ResearchChatPageWrapper = () => {
  const { id: projectId = "" } = useParams();

  const { isLoading, data: manifest } = useRequest(
    async () => {
      if (!projectId) return null;
      return fetchManifest(projectId);
    },
    { manual: false, defaultParams: [] },
  );

  if (isLoading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <Loader2 className="h-10 w-10 animate-spin text-blue-500" />
      </div>
    );
  }

  return (
    <ResearchChatPage
      projectId={projectId}
      files={manifest?.files ?? []}
    />
  );
};
